<div data-bs-version="5.1" class="menu menu2 cid-ukB1xrv0t2" once="menu" id="menu2-0">
    <app-menu></app-menu>
</div>
<div class="app" style="margin-top: 2rem">
    <router-outlet></router-outlet>
    <ngx-spinner #ngxSpinnerComponent bdColor="rgba(0,0,0,0.1)" size="medium" color="#000" [fullScreen]="true"></ngx-spinner>
</div>
<button *ngIf="isVisibleBackButton" (click)="goBack()" id="back-btn" [tooltip]="'common.navigation_back' | translate">
    <img src="assets/icon/back.png" />
</button>
